import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-chevron-right",
  "use": "icon-chevron-right-usage",
  "viewBox": "0 0 9 17",
  "content": "<symbol viewBox=\"0 0 9 17\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-chevron-right\">\r\n<path d=\"M1.05908 1.6665L8.05908 8.6665L1.05908 15.6665\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol